// extracted by mini-css-extract-plugin
module.exports = {"globalTooltip":"src-styles___globalTooltip"};